<template>
  <div>
    <auth-header />
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner  postition-relative">
        <!-- <div
          class="bg-out-auth position-absolute top-0 left-0 w-100 h-100"
        ></div> -->
        <b-card class="mb-0 position-relative overflow-hidden" no-body>
          <b-card-body style="z-index: 10" class="p-2">
            <b-link class="brand-logo my-3">
              <div class="d-flex align-items-center justify-content-center">
                <div style="height: 24px" class="ml-50 position-relative">
                  <div class="rounded logo-shadow position-absolute"></div>

                  <b-img
                    style="max-height: 24px"
                    :src="require('@/assets/images/fxlegends/logo2.png')"
                    fluid
                    alt="FX Legends"
                  />
                </div>
              </div>
            </b-link>

            <h2 class="mb-1">Adventure starts here 🚀</h2>
            <b-card-text class="mb-2 h5" v-if="!$route.path.includes('verify')">
              Make your app management easy and fun!
            </b-card-text>
            <b-alert
              show
              variant="success"
              class="p-1 d-flex align-items-center"
              v-if="$route.path.includes('verify')"
              ><feather-icon icon="AlertCircleIcon" class="mr-25" />Confirm your
              email to complete the registration</b-alert
            >
            <!-- <b-button-group class="w-100" v-if="!$route.path.includes('verify')">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            :variant="
              $route.path.includes('partner') ? 'primary' : 'outline-primary'
            "
            :to="{ name: 'auth-partner-register' }"
          >
            I am a Partner
          </b-button>

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            :variant="
              $route.path.includes('user') ? 'primary' : 'outline-primary'
            "
            :to="{ name: 'auth-user-register' }"
          >
            I am a User
          </b-button>
        </b-button-group> -->
            <!-- form -->
            <router-view />
            <b-card-text
              class="text-center mt-2"
              v-if="$route.path.includes('verify')"
            >
              <b-link @click="logout">
                <feather-icon icon="ChevronLeftIcon" /> Wrong email
              </b-link>
            </b-card-text>
            <template v-if="!$route.path.includes('verify')">
              <b-card-text class="text-center mt-2">
                <span>Already have an account? </span>
                <b-link :to="{ name: 'auth-user-login' }">
                  <span>Sign in instead</span>
                </b-link>
              </b-card-text>
            </template>
          </b-card-body>
          <!-- <div
            class="bg-in-auth position-absolute top-0 left-0 w-100 h-100"
          ></div> -->
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BLink,
  BCardTitle,
  BCardText,
  BButton,
  BButtonGroup,
  BAlert,
  BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import AuthHeader from "../auth-header/AuthHeader.vue";
export default {
  components: {
    // BSV
    BCard,
    BCardBody,
    BLink,
    BCardTitle,
    BCardText,
    BButton,
    BButtonGroup,
    BAlert,
    BImg,
    AuthHeader,
  },
  directives: {
    Ripple,
  },

  methods: {
    async logout() {
      // Remove userData from localStorage
      try {
        const { data } = await this.$http.post("auth/user/logout");
        localStorage.removeItem("userData");
        this.$store.dispatch("auth/setUserData", {});
        localStorage.removeItem("token");
        this.$http.defaults.headers.common["Authorization"] = ``;
        // Redirect to login page
        this.$router.push({ name: "auth-user-register" });
      } catch (err) {}
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
